import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ClassInitService } from '../class-init.service';
import { MenuConfigService } from '../menu-config.service';
import { BurolarService } from '../http_services/genel/burolar.service';
import { ProgressSpinnerService } from '@core/_shared/progress-spinner/progress-spinner.service';
import { Router } from '@angular/router';
import { AktifKullaniciBilgisiService } from '@core/auth/aktif-kullanici-bilgisi.service';
import { environment } from '@environments/environment';
import { LoginTipleri, KullaniciTipleri } from '@core/genel/AppEnums';

@Injectable()
export class MenuHorizontalService {
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	onGecerliBuroUpdated$: BehaviorSubject<boolean> = new BehaviorSubject(false);
	gecisYapilabilecekBurolar: any;
	gecerliBuroId?: number = 0;
	attributes: any;
	menuClasses: string;
	itemsWithAsides = [];
	loginTipi: number = environment.LOGIN_TIPI;

	constructor(
		private classInitService: ClassInitService,
		private burolarService: BurolarService,
		private progressSpinnerService: ProgressSpinnerService,
		private menuConfigService: MenuConfigService,
		public aktifKullaniciBilgisiService: AktifKullaniciBilgisiService,
		private router: Router
	) {

		// this.menuConfigService.onMenuUpdated$.subscribe(model => {
		// 	this.menuList$.next(objectPath.get(model.config, 'header.items'));
		// });

		// bürolar arası geçiş sadece turkFatura için kullanılıyor ve İzleyici tipindeki kullanıcı kullanamaz
		if (this.loginTipi == LoginTipleri.turkFatura) {
			this.aktifKullaniciBilgisiService.aktifKullaniciBilgisi$.subscribe(model => {
				if (model) {
					if (model.ID !== undefined && model.ID !== null && model.ID !== 0 && model.KLNC_TYP_ID != KullaniciTipleri.Izleyici){
						
					}
						// this.gecisYapilabilecekBurolariYukle();
				}
			});
		}

		// subscribe to menu classes update
		this.classInitService.onClassesUpdated$.subscribe(classes => {
			// default class
			this.menuClasses =
				'm-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas';
			// join the classes array and pass to variable
			// add classes to this host binding class
			this.menuClasses += ' ' + classes.header_menu.join(' ');
		});
	}

	gecisYapilabilecekBurolariYukle() {
		this.progressSpinnerService.show();
		this.burolarService.gecisYapilabilecekBurolariGetir().subscribe(
			data => {
				this.gecisYapilabilecekBurolar = data; //buroları yalin haliyle tut
				data = this.dataDuzenle(data);
				this.menuList$.next(data);
				this.progressSpinnerService.hide();
			},
			() =>
				this.progressSpinnerService.hide(),
			() =>
				this.progressSpinnerService.hide()
		)
	}

	aktifBuroDegistir(buroId: number) {
		this.progressSpinnerService.show();

		//gecerli büroyu pasif yap
		if (this.gecisYapilabilecekBurolar) {
			this.gecisYapilabilecekBurolar.BUROLAR.forEach(buro => {
				if (buro.GECERLI_BURO)
					buro.GECERLI_BURO = false;
			});
		}
		//secilen buroyu aktif yap
		let aktifYapilacakBuro = this.gecisYapilabilecekBurolar.BUROLAR.find(t => t.BURO_ID == buroId);
		aktifYapilacakBuro.GECERLI_BURO = true;
		this.gecerliBuroId = aktifYapilacakBuro.BURO_ID;

		//aktiflik bilgisini ui da gösterebilmek için datayı tekrar düzenle
		let data = this.dataDuzenle(this.gecisYapilabilecekBurolar);
		this.menuList$.next(data);

		// anasayfaya yönlendir
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
			this.router.navigate(['/']);
		});

		this.onGecerliBuroUpdated$.next(true); // Geçerli büro değiştirilince yayın yap
		this.progressSpinnerService.hide();
	}

	dataDuzenle(data: any) {
		if (data) {
			let baslik = data.BUROLAR.find(s => s.GECERLI_BURO == true);
			this.gecerliBuroId = baslik.BURO_ID;
			let items: any = [];
			let item = {
				title: baslik.UNVAN,
				root: true,
				icon: 'flaticon-add',
				toggle: 'click',
				submenu: {
					type: 'classic',
					alignment: 'left',
					items: data.BUROLAR.filter(s => s.GECERLI_BURO == false).map((item) => ({
						title: item.UNVAN,
						icon: 'flaticon-users',
						tooltip: item.UNVAN,
						buroId: item.BURO_ID
					}))
				}
			}
			items.push(item);
			return items;
		}
	}
}
